<template>
	<b-card header-tag="header">
		<template #header style="position: relative">
			<b-row>
				<b-col>
					<h4><b>Главное меню</b></h4>
				</b-col>
				<b-col @click="$router.push('/')">
					<img src="/img/brand/dwpost.png" style="width: 185px; position: absolute; top: -10px; right: 25%" alt="">
				</b-col>
				<b-col align="right">
					<h4 class="mr-2"><b>@ {{ username }}</b></h4>
				</b-col>
				<b-col @click="logout" cols="1">
					<b-button size="sm">
						<i style="font-size: 15px" class="fas fa-sign-out-alt text-danger mr-1"/> <b>Выйти</b>
					</b-button>
				</b-col>
			</b-row>
		</template>
		<b-row class="mt-3">
			<b-col align="center">
				<h4 class="d-inline-block mr-4"><b>{{ $t('promo-to-product.department') }}:</b></h4>
				<span style="font-size: 20px">{{depName}}</span>
			</b-col>
			<b-col align="center">
				<h4 class="d-inline-block mr-4"><b>{{ $t('kassa.nomer') }}:</b></h4>
				<span style="font-size: 20px">{{cashBoxName}}</span>
			</b-col>
		</b-row>
		<b-row class="mt-5">
			<b-col>
				<b-button :disabled="disibl"  @click="returnComponentModal = true" style="width: 100%; padding: 40px">
					<i style="font-size: 40px" class="fa fa-undo text-success mb-3"/>
					<h5><b>Возврат</b></h5>
				</b-button>
			</b-col>
			<b-col>
				<b-button :disabled="disibl" @click="spiska()" style="width: 100%; padding: 40px">
					<i style="font-size: 40px" class="fa fa-list text-dark mb-3"/>
					<h5><b>Список Продаж</b></h5>
				</b-button>
			</b-col>
			<b-col>
				<b-button :disabled="disibl" @click="xreportOpen" style="width: 100%; padding: 40px">
					<i style="font-size: 40px" class="fa fa-close text-success mb-3"/>
					<h5><b>Х-отчёт</b></h5>
				</b-button>
			</b-col>
		</b-row>
		<b-row class="mt-5">
			<b-col>
				<b-button :disabled="disibl" @click="$router.push('/point-of-sale/transfer-income')" style="width: 100%; padding: 40px">
					<i style="font-size: 40px" class="fa fa-cloud-download text-info mb-3"/>
					<h5><b>Приход</b></h5>
				</b-button>
			</b-col>
			<b-col>
				<b-button :disabled="disibl" @click="toPos" style="width: 100%; padding: 40px">
					<i style="font-size: 40px" class="fa fa-plus-circle text-primary mb-3"/>
					<h5><b>Начать Продажу</b></h5>
				</b-button>
			</b-col>
			<b-col>
				<b-button :disabled="disibl" @click="confirmEndSession = true" style="width: 100%; padding: 40px">
					<p style="font-size: 35px" class="text-danger mb-1"><b>Z</b></p>
					<h5><b>Z-отчёт</b></h5>
				</b-button>
			</b-col>
		</b-row>

		<!-- Z-REPORT END SESSION MODAL -->
		<b-modal v-model="confirmEndSession" @ok="closeAndPrintZReport" @cancel="confirmEndSession = !confirmEndSession" ok-title="Да" cancel-title="Отмена">
			<h4>{{ $t('zOtchet.title') }}</h4>
		</b-modal>

		<!-- Z-REPORT VIEW MODAL -->
		<b-modal v-model="zreport" size="lg" hide-footer :no-close-on-esc="true" :no-close-on-backdrop="true" hide-header class="body-padding-0">
			<x-and-z-report v-if="zreport" is-z-report @close="closeZreport"></x-and-z-report>
		</b-modal>

		<!-- X-REPORT VIEW MODAL -->
		<b-modal v-model="xreport" size="lg" hide-footer hide-header :no-close-on-esc="true" :no-close-on-backdrop="true" class="body-padding-0">
			<x-and-z-report v-if="xreport" @close="closeXreport"></x-and-z-report>
		</b-modal>

		<!-- RETURN MODAL -->
		<b-modal v-model="returnComponentModal" size="lg" hide-footer hide-header :no-close-on-esc="true" :no-close-on-backdrop="true">
			<template>
				<return-component :mode="'retail'" :show-return-modal="returnComponentModal" @close="closeReturnModal"/>
			</template>
		</b-modal>
	</b-card>
</template>

<script>
import Multiselect from 'vue-multiselect'
import XAndZReport from "@/views/point-of-sale/pos/components/Xreport/XAndZReport";
import ReturnComponent from "@/views/return-component/ReturnComponent";
import {mapActions, mapGetters, mapState} from 'vuex'
import {TokenService} from "../../../services/storage.service";
import ApiService from "../../../services/api.service";
import FBoxService from "../../../services/fbox.service";
import PosService from "../../../services/pos.service";
import DepartmentsService from "@/services/departments.sevice";
import UsersService from "@/services/users.sevice";

export default {
	name: "before_pos",
	components: {Multiselect, XAndZReport, ReturnComponent},
	data() {
		return {
			selectDeparmentList:[],
			selectedDepartment:null,
			checkoutNumber:null,
			checkoutNumberList:[],
			selectedDepForSearch: null,
			cashboxList: [],
			selectedDep: null,
			refInputNotFilled: false,
			modalForAdding: false,
			cashboxnumber: '',
			show: false,
			errorShow: false,
			cashboxId: null,
			savedCashboxId: null,
			confirmEndSession: false,
			zreport: false,
			xreport: false,
			returnComponentModal: false,
			fiscalData: {}
		}
	},
	computed: {
		...mapGetters('departments', ['myDepartments']),
		...mapState("zetReport", ["currentReport"]),
		username() {
			return TokenService.getUserName();
		},
		cashBoxName(){
			return localStorage.getItem('cash_number')
		},
		depName(){
			return localStorage.getItem('dep_name')
		},
		disibl(){
			if (this.cashBoxName || this.depName){
				return false
			}
			else {
				return true
			}
		}
	},
	watch: {
		'fiscalData': {
			handler(d) {
				localStorage.setItem('cash_id', d.id)
				localStorage.setItem('dep_id', d.departmentId)
				localStorage.setItem('dep_name', d.departmentName)
				localStorage.setItem('ip_address', d.ipAddress)
				localStorage.setItem('cash_number', d.name)
				localStorage.setItem('is_bar', d.isBar)
				localStorage.setItem('is_sky_shop', d.isSkyShop)
				localStorage.setItem('document_type', '1')
				localStorage.setItem('dep_currency_code', d.depCurrencyType)
			}
		},
	},
	methods: {
		spiska(){
			this.$router.push(`/point-of-sale/sales-for-seller/${localStorage.getItem('dep_id')}/${localStorage.getItem('cash_id')}`)
		},
		...mapActions('departments', ['fetchMyDepartments']),
		...mapActions('zetReport', ['startSessionToDep', 'getCurrentXReport']),
		closeReturnModal() {
			this.returnComponentModal = false;
		},
		async closeAndPrintZReport(okEvent) {
			let type = localStorage.getItem('document_type')
			if (type && type==1) {
				this.confirmEndSession = false
				this.zreport = true
			} else if (type && type==2) {
				await PosService.getKkmSaleCount(localStorage.getItem('dep_id'), localStorage.getItem('cash_id')).then(async (res) => {
					if (res.data === 0) {
						okEvent.preventDefault();
						if (!localStorage.getItem('cash_id')) {
							this.$vs.notify({
								title: 'Продажа не было...',
								color: 'danger',
								icon: 'close',
								position: 'top-right'
							});
							return 0;
						}
						await this.getCurrentXReport(localStorage.getItem('dep_id'))
						let resFromFBox = null;
						let errMsgFromFBox = null;
						try {
							resFromFBox = await FBoxService.xAndZReportCloseOrPrint({
								ipAddress: localStorage.getItem('ip_address'),
								data: this.currentReport.payments,
								closeZReport: true,
								salesEur: this.currentReport.salesEuro,
								totalEur: this.currentReport.totalWithDiscount - this.currentReport.totalRefundAmount,
							});
						} catch (e) {
							if (e.request && e.request.response) {
								let response = JSON.parse(e.request.response);
								errMsgFromFBox = response.message;
							}
						}
						if (resFromFBox && resFromFBox.data.is_success) {
							this.confirmEndSession = false
							this.zreport = true
						} else {
							let fbError = resFromFBox ? resFromFBox.data.error.message : (errMsgFromFBox ? errMsgFromFBox : 'XATOLIK: Iltimos, qayta urunib ko\'ring')
							this.$vs.notify({
								title: fbError,
								color: 'danger',
								icon: 'close',
								position: 'top-right'
							});
						}
					} else {
						this.$vs.notify({
							title: 'Сначала отправьте все чеки',
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					}
				}).catch(er => {
					this.$vs.notify({
						title: er.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			}
		},
		xreportOpen() {
			if (!localStorage.getItem('cash_id')) {
				this.$vs.notify({
					title: 'Пожалуста выберите кассу',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
				return 0;
			} else {
				localStorage.getItem('cash_id','dep_id')
				this.xreport = true
			}
		},
		closeZreport() {
			this.zreport = false
			this.$router.go()
			if (TokenService.getUserRoles() == 'seller') {
				this.$store.dispatch('logout')
			}
		},
		closeXreport() {
			this.xreport = false
		},
		async toPos() {
			if (localStorage.getItem('dep_id') && localStorage.getItem('cash_id')) {
				this.$router.push(`/point-of-sale/pos-v2/${localStorage.getItem('dep_id')}/${localStorage.getItem('cash_id')}`)
			} else {
				this.$vs.notify({
					title: 'Пожалуста выберите кассу',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		logout() {
			this.$store.dispatch('logout')
		},
	},
	async created() {
		let depId = localStorage.getItem('dep_id');
		await UsersService.getPermittedDepartments().then(response => {
			this.selectDeparmentList = response.data.permittedDepartments;
		}).catch(e => {
			this.$vs.notify({
				title: e.message,
				color: 'danger',
				icon: 'close',
				position: 'top-right'
			});
		})
		if (depId && this.selectDeparmentList.length > 0) {
			this.selectDeparmentList.forEach(d => {
				if (d.id == Number(depId))
					this.selectedDepartment = d
			})
		} else {
			this.selectedDepartment = null
		}
	}
}
</script>

<style scoped>

</style>
